import { StylesConfig } from "react-select";
import { StylesMergePolicy } from "./Select";

export const getStyles = <OptionType, IsMulti extends boolean>(styles: StylesConfig<OptionType, IsMulti>, stylesMergePolicy: StylesMergePolicy): StylesConfig<OptionType, IsMulti> => {

  const extendedStyles = stylesMergePolicy === "merge" ? styles : {} as StylesConfig<OptionType, IsMulti>;
  const overriddenStyles = stylesMergePolicy === "override" ? styles : {} as StylesConfig<OptionType, IsMulti>;


  return {
    menu(base, props) {
      return {
        ...base,
        marginBottom: 2,
        marginLeft: 0,
        marginRight: 0,
        marginTop: 2,
        minWidth: 250,
        backgroundColor: "var(--white)",
        borderRadius: "4px",
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        boxShadow: "0 0 0 1px var(--gray-90-color)",
        position: "static",
        ...extendedStyles.menu?.(base, props),
      };
    },
    menuList(base, props) {
      return {
        ...base,
        padding: 0,
        borderRadius: "4px",
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        ...extendedStyles.menuList?.(base, props),
      };
    },
    menuPortal(base, props) {
      return {
        ...base,
        zIndex: 2000,
        minWidth: 250,
        ...extendedStyles.menuPortal?.(base, props),
      };
    },
    container(base, props) {
      return {
        ...base,
        padding: 0,
        ...extendedStyles.container?.(base, props),
      };
    },
    placeholder(base, props) {
      return {
        ...base,
        fontSize: "16px",
        fontWeight: 300,
        fontStretch: "normal",
        fontStyle: "normal",
        color: "var(--gray-50-color)",
        ...extendedStyles.placeholder?.(base, props),
      };
    },
    control(base, props) {
      return {
        ...base,
        borderColor: undefined,
        borderRadius: undefined,
        borderStyle: undefined,
        borderWidth: undefined,
        border: undefined,
        boxShadow: undefined,
        backgroundColor: undefined,
        ...extendedStyles.control?.(base, props),
      };
    },
    clearIndicator(base, props) {
      return {
        ...base,
        padding: undefined,
        ...extendedStyles.clearIndicator?.(base, props),
      };
    },
    input(base, props) {
      return {
        ...base,
        ...extendedStyles.input?.(base, props),
      };
    },
    option(base, props) {
      return {
        ...base,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        backgroundColor: props.isFocused
          ? "var(--cheerful-blue-color)"
          : props.isSelected
            ? "var(--gray-90-color)"
            : "transparent",
        color: props.isDisabled
          ? "var(--gray-50-color)"
          : props.isFocused
            ? "var(--white)"
            : "var(--gray-0-color)",
        fontSize: "13px",
        minHeight: "35px",
        padding: undefined,
        ":active": {
          backgroundColor:
            props.isDisabled ? "var(--gray-90-color)" : "var(--cheerful-blue-color)",
        },
        ":not(:last-child)": {
          borderTop: "1px solid transparent",
          borderBottom: "1px solid var(--gray-90-color)",
        },
        ...extendedStyles.option?.(base, props),
      };
    },
    singleValue(base, props) {
      return {
        ...base,
        fontSize: "16px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        textAlign: "left",
        color: undefined,
        ...extendedStyles.singleValue?.(base, props),
      };
    },
    dropdownIndicator(base, props) {
      return {
        ...base,
        color: "var(--gray-60-color)",
        ":hover": {
          color: "var(--cheerful-blue-color)",
        },
        ...extendedStyles.dropdownIndicator?.(base, props),
      };
    },
    valueContainer(base, props) {
      return {
        ...base,
        paddingRight: 0,
        ...extendedStyles.valueContainer?.(base, props),
      };
    },
    ...overriddenStyles,
  };
};

export default getStyles;
